import {useContext} from 'react';
import {useParams, useRouteMatch} from 'react-router-dom';
import {AssociateUserCardForm} from '../../../../../../../components/associate-user-card-form/associate-user-card-form';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';

export default function ProfessionalCaregiverAssociateUserCardProfessionalCaregiverOfficeScreen() {
  // Get params
  let {id, entityId}: {id?: string; entityId?: string} = useParams();

  // Get context
  const officeContext: OfficeContextType = useContext(OfficeContext);

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <AssociateUserCardForm
      caregiverMode={CaregiverMode.Professional}
      entityId={entityId || ''}
      userId={id || ''}
      userName={officeContext.state.userForm?.user.name || ''}
      redirectUrl={`${url.replace('/associate', '')}`}
    />
  );
}
